<template>
  <div>
    <transition name="fade">
      <slot v-if="visible"></slot>
    </transition>
  </div>
</template>

<script>
export default {
  name: "FadeIn",

  props: ['default'],

  data() {
    return {
      visible: false
    };
  },
  methods: {
    handleScroll() {
      if (!this.visible) {
        var top = this.$el.getBoundingClientRect().top
        this.visible = top < window.innerHeight
      }
    }
  },
  created() {
    window.addEventListener('scroll', this.handleScroll);
    this.visible = this.default
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 2s
}

.fade-enter,
.fade-leave-to {
  opacity: 0
}
</style>
